<template>
  <div>
    <JamboreeToolbar/>
    <div class="card  mx-md-5 mt-3 mb-3 bg-form">
      <card-header
        :title="$t('jamboree.createTitle')"
        :iconName="'person-fill'"
      />
      <b-overlay :show="isLoading" spinner-variant="primary" rounded="sm">
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <b-row>
            <v-select
                :options="this.jamboreeList"
                v-model="selectedJamboree"
                :placeholder="$t('jamboree.selectJamboree')"
                label="title"
                class="bg-white rounded col"
            />

          <v-select
              :options="this.usersAccessibleUnits"
              v-model="selectedUnit"
              :placeholder="$t('jamboree.selectUnit')"
              label="name"
              class="bg-white rounded col"
          />
        </b-row>

        <member-selector
            v-for="plan in jamboreePayment.jamboree.paymentPlans" :key="plan.id"
            :members-list="unitMembersList.filter(m=>plan.memberTypes.includes(m.type))"
            :excursion-members="selectedMembers.filter(r=>r.jamboreeParticipationType.id === plan.id)"
            :jamboreeParticipationType="plan"
            v-on:member:update.capture="updateMembers"
            :current-census="currentCensus"
            :show-comment="false"
        />


      </b-card-body>
      <b-card-footer>

        <b-button  type="submit" variant="success" @click="createJamboreePayment(jamboreePayment)" :disabled="isLoading">
          {{ $t("common.save")}}
        </b-button>

      </b-card-footer>
    </b-overlay>
    </div>
  </div>
</template>

<script>
import cardHeader from '../../components/common/cardHeader.vue'
import memberService from '../../services/member.service';
import { handleApiError } from '../../services/error.service';
import {roles, routes} from "esep/src/services/routing.service";
import {hasRole} from "esep/src/services/utils";
import memberSelector from "@/components/common/memberSelector";
import JamboreeToolbar from "@/views/jamboree/JamboreeToolbar";

export default {
  components: { cardHeader, memberSelector, JamboreeToolbar },
  data() {
    return {
      popAlert: false,
      errors: [],
      popSuccessAlert: false,
      successMessage: null,
      jamboreeList: [],
      jamboreePayment: {unit: {}, paymentMembers:[], jamboree: {paymentPlans: []}},
      usersAccessibleUnits: [],
      unitMembersList: [],
      selectedJamboree: null,
      selectedUnit: null,
      currentCensus: null,
      isLoading: false,
      MEMBER_TYPES: [
        { value: "CUB", text: "Λυκόπουλο" },
        { value: "SCOUT", text: "Πρόσκοπος" },
        { value: "VENTURE", text: "Ανιχνευτής" },
        { value: "ROVER", text: "Μέλος Δικτύου" },
        { value: "LEADER", text: "Βαθμοφόρος" },
        { value: "SUPPORT", text: "Μέλος Ε.Κ.Σ." },
        { value: "OLD_SCOUT", text: "Παλαιός πρόσκοπος" }
      ],
      approvedMembers: [],
      selectedMembers: []
    }
  },
  // computed: {
  //   selectedUnit() {
  //     return this.jamboreePayment.unit;
  //   },
  // },
  watch: {
    selectedUnit() {
      if (this.selectedUnit.id) {
        this.$store.state.globalUnitId = String(this.selectedUnit.id);
        localStorage.setItem('global-selected-unit-id', String(this.selectedUnit.id));
      } else {
        this.$store.state.globalUnitId = null;
        localStorage.clear('global-selected-unit-id');
      }
      this.getUnitsMembers();
    },
    selectedJamboree(newJamboree) {
      this.jamboreePayment.jamboree = newJamboree;
      this.getUnitsMembers();
    }
  },
  mounted() {
    memberService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.members.census.add)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchAccessibleUnits();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getJamborees();
    memberService.getCurrentCensusPeriod().then(
        (response) => {
          this.currentCensus = response.data.yearCensus;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
    )

  },
  methods: {
    getUnitsMembers() {
      this.unitMembersList = [];
      this.approvedMembers = [];
      if (this.jamboreePayment?.jamboree?.id === undefined || this.selectedUnit.id === undefined) {
        return;
      }
      memberService.getJamboreeApprovedMembers(this.jamboreePayment.jamboree.id, this.selectedUnit.id).then(
          (response) => {
            this.approvedMembers = response.data;
            this.unitMembersList = this.approvedMembers.map(x => ({...x.member}));

          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      )
    },
    fetchAccessibleUnits(){
      memberService.getAccessibleUnits(this.username).then(
          (response) => {
            this.usersAdminableUnits = response.data.ADMIN_UNIT;
            this.$store.state.usersAdminableUnits = this.usersAdminableUnits;
            this.usersModableUnits = response.data.MOD_UNIT;
            this.$store.state.usersModableUnits = this.usersModableUnits;
            this.usersAccessibleUnits = response.data.VIEW_UNIT;
            this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;
            if(this.usersAccessibleUnits.length == 1) {
              this.selectedUnit = this.$store.state.userInfo.orgMember.orgUnit;
            } else {
              this.selectedUnit = this.usersAccessibleUnits.find((unit) => unit.id == parseInt(this.$store.state.globalUnitId));
            }
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      );
    },
    unitChanged(unit) {
      if( unit != null) {
        this.selectedUnit = this.usersAccessibleUnits.find((usersAccessibleUnit) => usersAccessibleUnit.id == unit.id);
        this.getUnitsMembers();
      } else {
        this.selectedUnit = null;
      }
    },
    handleError(errors) {
      errors.forEach(error => {
        console.error(error);
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    createJamboreePayment(jamboreePayment){
      this.isLoading= true;
      jamboreePayment.unit = this.selectedUnit;
      jamboreePayment.jamboree = this.selectedJamboree;
      jamboreePayment.paymentMembers = this.selectedMembers.map(x => ({amount: x.amount, jamboreeMember: this.approvedMembers.find(m=>m.member.id === x.member.id)}));
      memberService.createJamboreePayment(jamboreePayment).then(
          response => {
            this.jamboreePayment = response.data;
            this.$router.push({name: 'jamboreePaymentEditView',params: { id: response.data.id }});
            this.isLoading = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
            this.isLoading = false;
          }
      );
    },
    updateMembers(membersInfo){
      this.selectedMembers = this.selectedMembers.filter(r=>r?.jamboreeParticipationType?.id !== membersInfo.plan.id);
      this.selectedMembers = this.selectedMembers.concat(membersInfo.members);
    },
    getJamborees() {
      memberService.getJamborees().then(
        (response) => {
            this.jamboreeList = response.data.filter((j) => j.canPay);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
  }
}
</script>